// dependencies
import cn from 'classnames';
// components
import Modal from '@mui/material/Modal';
// styling
import { buttonCss, popUpsCss } from '@digital_monorepo/styling';

const ActionModal = ({ t, open, i18nPath, onClose, noAction, yesAction }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby='child-modal-title' aria-describedby='child-modal-description'>
      <div className={popUpsCss.modalContainer}>
        <div className={popUpsCss.modalHeader}>{t(`${i18nPath}.title`)}</div>
        <div className={popUpsCss.modalBody}>
          <div>{t(`${i18nPath}.text`)}</div>
        </div>
        <div className={popUpsCss.modalFooter}>
          {noAction && (
            <button className={cn(buttonCss.secondaryBtn, buttonCss.medium)} onClick={noAction}>
              {t(`${i18nPath}.btn_no`)}
            </button>
          )}
          {yesAction && (
            <button className={cn(buttonCss.primaryBtn, buttonCss.medium)} onClick={yesAction}>
              {t(`${i18nPath}.btn_yes`)}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
